import createApiClient from "./api";

const api = createApiClient();

export const fetchSpecSections = async (
  projectId,
  page = 1,
  pageSize = 1000,
  filters = {}
) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/spec-sections`, {
    params: {
      project_id: projectId,
      skip: (page - 1) * pageSize,
      limit: pageSize,
      filters: JSON.stringify(filters),
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const { data, total } = response.data;
  return { specSections: data, total };
};

export const createSpecSection = async (specSectionData) => {
  const token = localStorage.getItem("token");
  const response = await api.post("/spec-sections", specSectionData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const deleteSpecSection = async (specSectionId) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(`/spec-sections/${specSectionId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const copySpecSectionsFromProject = async (sourceProjectId, targetProjectId) => {
  const token = localStorage.getItem("token");
  const response = await api.post(
    "/spec-sections/copy-from-project",
    { source_project_id: sourceProjectId, target_project_id: targetProjectId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const updateSpecSection = async ({ specSectionId, specSectionData }) => {
  const token = localStorage.getItem("token");
  const response = await api.put(
    `/spec-sections/${specSectionId}`,
    specSectionData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const bulkCreateSpecSections = async (bulkData) => {
  const token = localStorage.getItem("token");
  const response = await api.post("/spec-sections/bulk", bulkData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
